import { useQuery } from 'react-query'
import { getStates } from '../general'

export default function useStates() {
  const { data, error, isLoading } = useQuery('states', () => getStates())
  return { data, error, isLoading }
}
